import React, { useState, useEffect } from 'react';
import css from './SectionFirebaseReviews.module.css';
import { post } from '../../../util/api';
import { IconSpinner } from '../../../components';
import ReviewCard, { star } from './ReviewCard';

const SectionFirebaseReviews = ({ listingId }) => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    post('/api/firebase/query-collection', {
      collectionName: 'reviews',
      key: 'listing_id',
      value: listingId,
    })
      .then((resp) => {
        if (resp.length) setReviews(resp);
        setLoading(false);
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className={css.wrapper} id="reviews_section">
        <p className={css.title}>Reviews</p>
        <IconSpinner />
      </div>
    );
  }

  const averageRating =
    reviews.reduce((acc, review) => acc + review?.data?.rating, 0) / reviews?.length;
  const numberOfReviews = reviews.length;
  return (
    <div className={css.wrapper} id="reviews_section">
      <p className={css.title}>
        Reviews
        {!!numberOfReviews && (
          <div className={css.avgRating}>
            <span>{star}</span>
            <span>{averageRating.toFixed(1)}</span>
            <span>
              {numberOfReviews > 1 ? `(${numberOfReviews} reviews)` : `(${numberOfReviews} review)`}
            </span>
          </div>
        )}
      </p>

      {reviews.length > 0 ? (
        <>
          {reviews.map((review) => (
            <ReviewCard review={review} />
          ))}
        </>
      ) : (
        <div className={css.noReviewsWrapper}>
          <span className={css.noReviewsText}>No reviews yet</span>
        </div>
      )}
    </div>
  );
};

export default SectionFirebaseReviews;
